module.exports = __webpack_public_path__ + "static/img/creator_country_invite_frame.32fd7a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/creator/creator_country_invite_frame.png
// module id = DZwL
// module chunks = 0